import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Crown, Users, Smartphone, Wallet } from 'lucide-react';
const withoutPack = ['Organizás tu consultorio pero sin estrategia de crecimiento', 'Armás tus honorarios a ojo sin saber si estás cobrando bien', 'No tenés herramientas para conseguir más pacientes', 'Sin guía para construir tu presencia digital profesional'];
const withPack = ['6 tomos clínicos + 6 bonos operativos + 3 guías Élite de negocio', 'Sabés exactamente cómo fijar, comunicar y aumentar tus honorarios', 'Tenés un plan concreto para llenar tu agenda de pacientes', 'Construís tu marca digital con un sistema probado paso a paso'];
const eliteTools = [{
  icon: Users,
  title: 'Consultorio Lleno',
  desc: 'La guía completa para conseguir más pacientes, retenerlos y hacer crecer tu consultorio con un plan de acción de 90 días.'
}, {
  icon: Smartphone,
  title: 'Nutricionista Digital',
  desc: 'Cómo construir tu marca personal y atraer pacientes desde Instagram y TikTok, aunque nunca hayas publicado contenido profesional.'
}, {
  icon: Wallet,
  title: 'El Precio Justo',
  desc: 'Cómo fijar tus honorarios, cobrar sin miedo y aumentar tus ingresos sin trabajar más horas.'
}];
export function PackCompleto() {
  return <section className="py-14 bg-gray-50" data-id="element-145">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-146">
        {/* Header */}
        <div className="text-center mb-8 max-w-3xl mx-auto" data-id="element-147">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3" data-id="element-148">
            Qué vas a obtener con el{' '}
            <span className="text-nutri-medium" data-id="element-149">PACK COMPLETO</span>
          </h2>
          <p className="text-gray-500 text-base" data-id="element-150">
            La diferencia entre tener planillas básicas y un sistema profesional
            completo de gestión
          </p>
        </div>

        {/* Comparison Cards */}
        <div className="grid md:grid-cols-2 gap-5 mb-12 max-w-4xl mx-auto" data-id="element-151">
          {/* Without Pack */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm" data-id="element-152">
            <span className="inline-flex items-center gap-2 bg-gray-100 text-gray-500 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-4" data-id="element-153">
              <X size={14} data-id="element-154" /> Si no tenés Pack Completo
            </span>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-4" data-id="element-155">
              Solo tenés las planillas base
            </h3>
            <ul className="space-y-3 text-sm md:text-base" data-id="element-156">
              {withoutPack.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-600" data-id="element-157">
                  <X size={18} className="text-red-400 flex-shrink-0 mt-0.5" data-id="element-158" />
                  <span data-id="element-159">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* With Pack - Recommended */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-nutri-black rounded-2xl p-6 border-2 border-nutri-cta shadow-2xl relative" data-id="element-160">
            <div className="absolute top-0 right-6 -translate-y-1/2 bg-nutri-cta text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full flex items-center gap-1.5 shadow-md" data-id="element-161">
              <Crown size={14} fill="currentColor" data-id="element-162" /> Recomendado
            </div>
            <span className="inline-flex items-center gap-2 bg-nutri-medium/30 text-nutri-mint text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-4" data-id="element-163">
              <Check size={14} data-id="element-164" /> Si tenés el Pack Completo
            </span>
            <h3 className="text-lg md:text-xl font-bold text-white mb-4" data-id="element-165">
              Tenés un sistema completo de consultorio y negocio
            </h3>
            <ul className="space-y-3 text-sm md:text-base" data-id="element-166">
              {withPack.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-200" data-id="element-167">
                  <Check size={18} className="text-nutri-cta flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-168" />
                  <span data-id="element-169">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Elite Tools */}
        <div className="text-center mb-8" data-id="element-170">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-1" data-id="element-171">
            3 herramientas exclusivas del Pack Completo
          </h3>
          <p className="text-gray-500 text-sm" data-id="element-172">
            Solo disponibles si elegís el Pack Completo
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4" data-id="element-173">
          {eliteTools.map((tool, i) => {
          const Icon = tool.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white rounded-2xl p-5 border border-gray-200 shadow-sm hover:border-nutri-mint transition-colors" data-id="element-174">
                <div className="flex items-center gap-2.5 mb-3" data-id="element-175">
                  <div className="bg-nutri-mint/20 text-nutri-medium p-2.5 rounded-xl" data-id="element-176">
                    <Icon size={20} data-id="element-177" />
                  </div>
                  <span className="text-xs font-bold uppercase tracking-wider text-nutri-medium" data-id="element-178">
                    Élite #{i + 1}
                  </span>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-179">
                  {tool.title}
                </h4>
                <p className="text-gray-600 leading-relaxed text-sm" data-id="element-180">
                  {tool.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}